module.exports = __webpack_public_path__ + "static/media/plane.b3b2dcc1.svg";